import Icon, { IconName } from '@/components/Icon/Icon';
import { brandColors } from '@/styles/sunrunTheme.styles';

import useStyles from './IconListItems.styles';

export enum ListType {
  Excluded = 'Excluded',
  Included = 'Included',
  Additional = 'Additional',
}

export type IconListItemsProps = {
  items: string[];
  type: ListType;
  isOnDark: boolean;
};

const ListItemMap = {
  Included: {
    onLightColor: brandColors.mediumBlue,
    onDarkColor: brandColors.tintsChargeBlue60,
    name: IconName.CHECK_FILLED,
    testId: 'check-icon',
  },
  Additional: {
    onLightColor: brandColors.chargeBlue,
    onDarkColor: brandColors.tintsMediumBlue90,
    name: IconName.PLUS_FILLED,
    testId: 'plus-icon',
  },
  Excluded: {
    onLightColor: brandColors.chargeBlue,
    onDarkColor: brandColors.chargeBlue,
    name: IconName.EMPTY_CIRCLE,
    testId: 'circle-icon',
  },
};

const IconListItems = ({ items, type, isOnDark }: IconListItemsProps) => {
  const {
    name: iconName,
    onLightColor,
    onDarkColor,
    testId,
  } = ListItemMap[type];

  const { classes } = useStyles();

  return (
    <>
      {items?.map((item) => {
        return (
          <li key={`${type}-${item}`} className={classes.item}>
            <div>
              <Icon
                data-testid={testId}
                name={iconName}
                color={isOnDark ? onDarkColor : onLightColor}
                {...(type === ListType.Included && {
                  backgroundColor: isOnDark ? 'none' : 'white',
                })}
              />
            </div>
            <div className={classes.itemText}>{item}</div>
          </li>
        );
      })}
    </>
  );
};

export default IconListItems;
